module.exports = __webpack_public_path__ + "static/media/sp.20105791.png";